export default __webpack_public_path__ + "static/media/file-large.8af14daf.svg";